require('./accountLastMovementsTable.scss');

const PropTypes = require('prop-types');

const React = require('react');

const { FormattedText, getLanguage } = require('core/i18n').i18n;

const AccountLastMovementsTableRow = require('components/accounts/accountLastMovements/accountLastMovementsTableRow/accountLastMovementsTableRow');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const AccountLastMovementsMoreInfoRow = require('components/accounts/accountLastMovements/accountLastMovementsMoreInfoRow/accountLastMovementsMoreInfoRow');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { CategoriesModal } = require('components/commons/categoriesModal/categoriesModal');
const { CategoriesModalOld } = require('components/commons/categoriesModal/categoriesModalOld');

const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const { LAVANDA, PFM, PFM_NEW_FEATURES } = require('constants/flagBasedFeatures');

// @ helpers
const { recordLink } = require('utilities/tagging');

// @constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const { ACCOUNT_DEFERRABLE_PAYMENT } = require('constants/index');
const { ACTION_EVENT_VIEW, DEFERRAL_PAYMENT_ACCOUNT_ACTION_EVENT } = require('constants/tagging');

class accountLastMovementsTable extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            expandedRowId: ''
        };

        this.handleRowClick = this.handleRowClick.bind(this);
    }

    componentDidMount(){
        const { immTransactions } = this.props;
        this.recordTagAppearence(immTransactions.get('byId'));
    }

    componentWillReceiveProps(nextProps){
        const { immTransactions } = this.props;
        const { immTransactions: immNextTransactions } = nextProps;

        if (immTransactions.get('byId').size !== immNextTransactions.get('byId').size) {
            const transactions = immNextTransactions.get('byId').filterNot(transaction => immTransactions.get('byId').contains(transaction));
            this.recordTagAppearence(transactions);
        }
    }

    recordTagAppearence(transactions){
        const { flagBasedFeatures } = this.props;

        const atLeastOneDeferralPayment = transactions.some(movement => movement.get('finance') === ACCOUNT_DEFERRABLE_PAYMENT);
        flagBasedFeatures.get(LAVANDA) && atLeastOneDeferralPayment && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_ACCOUNT_ACTION_EVENT, ACTION_EVENT_VIEW);
    }

    getValueDateComponent() {
        const valueDateFormattedText = (
            <span>
                <FormattedText
                    value="myMoneyTransactions-valueDate"
                    className="account-last-movements-table__cell-header-date"
                    format="firstUppercase"
                />
            </span>
        );
        return (
            <OKTableCell asHeader>
                <OKTooltip
                    target={valueDateFormattedText}
                    content="myMoneyTransactions-valueDateTooltipText"
                />
            </OKTableCell>
        )
    }

    handleRowClick(rowId) {
        // If a click a expanded row, I must collapse it
        this.setState({
            expandedRowId: (rowId === this.state.expandedRowId) ? '' : rowId
        })
    }

    render() {
        const { immTransactions, immFilter, flagBasedFeatures, defaultLanguage } = this.props;
        const language = getLanguage(defaultLanguage);
        let table = <div></div>;

        if (immTransactions){
            const immMovementsByOrder = immTransactions.get('byOrder');
            const immMovementsById = immTransactions.get('byId');
            const categoryFormattedText = (//Don't remove the span tag it fix a bug with the tooltip
                <span>
                    <FormattedText value="myMoneyTransactions-category" format="firstUppercase" />
                </span>
            );
            const dateFormattedText = (
                <span>
                    <FormattedText
                        value={!__CONTACT_CENTER__ ? "myMoneyTransactions-date" : "myMoneyTransactions-operationDate"}
                        className="account-last-movements-table__cell-header-date"
                        format="firstUppercase"
                    />
                </span>
            );

            const categoryTooltip =(
                <OKTooltip
                    content="myMoneyTransactions-categoryTooltip"
                    offset={[0, -15]}
                    target={categoryFormattedText}
                    type="descriptive"
                />
            );



            table = (
                <div>
                    {
                        flagBasedFeatures.get(PFM_NEW_FEATURES) ?
                            <CategoriesModal />
                        :
                            <CategoriesModalOld byCategory />
                    }
                    <LastMovementsTable
                        immFilter={immFilter}
                        groupByDate
                        rowComponent={AccountLastMovementsTableRow}
                        immTransactionsByOrder={immMovementsByOrder}
                        immTransactionsById={immMovementsById}
                        columnsCount={flagBasedFeatures.get("account-revolving", false) ? 7 : 6}
                        groupHeaderClassName={'account-last-movements-table__group-header'}
                        expandedRowId={this.state.expandedRowId}
                        expandedRowComponent={AccountLastMovementsMoreInfoRow}
                        onRowClick={this.handleRowClick}
                        id={"account-last-movements"}
                        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                        charLimit={__CONTACT_CENTER__ ? 90 : undefined}
                        language={language}
                    >
                        <thead>
                            <OKTableRow asHeader>
                                <OKTableCell asHeader>
                                    <span></span>
                                </OKTableCell>
                                <OKTableCell asHeader>
                                    <OKTooltip
                                        content={!__CONTACT_CENTER__ ? "accounts-dateTooltip" : 'myMoneyTransactions-operationDateTooltipText'}
                                        offset={[0, -15]}
                                        target={dateFormattedText}
                                        type="descriptive"
                                    />
                                </OKTableCell>
                                <ContactCenterRender>
                                    {this.getValueDateComponent()}
                                </ContactCenterRender>
                                <FeatureTogglingRender notAllowedProductKey={PFM} >
                                    <OKTableCell asHeader={true} className="text-center">
                                        {categoryTooltip}
                                    </OKTableCell>
                                </FeatureTogglingRender>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="myMoneyTransactions-description" format="firstUppercase" />
                                </OKTableCell>
                                {flagBasedFeatures.get("account-revolving", false) &&  <OKTableCell asHeader />}
                                <OKTableCell asHeader className="account-last-movements-table__cell-header-import">
                                    <FormattedText value="myMoneyTransactions-amount" format="firstUppercase" />
                                </OKTableCell>
                                <OKTableCell asHeader className="account-last-movements-table__cell-header-balance">
                                    <FormattedText value="myMoneyTransactions-balance" format="firstUppercase" />
                                </OKTableCell>
                            </OKTableRow>
                        </thead>
                    </LastMovementsTable>
                </div>
            )
        }
        return table;
    }
}

accountLastMovementsTable.propTypes = {
    defaultLanguage: PropTypes.string,
    immFilter: PropTypes.object,
    immTransactions: PropTypes.object,
    flagBasedFeatures: PropTypes.object
};

module.exports = accountLastMovementsTable;
